import React, { KeyboardEventHandler, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { PopoverTrigger } from '@spotify-internal/encore-web/core';

import { useCustomer } from 'utils/user';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { NavBarAvatar } from 'components/Masthead/Header/Avatar';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';
import useDropdown from 'components/Masthead/Header/hooks/useDropdown';
import { NavBarProfileLinksPopoverOverlay } from 'components/Masthead/Header/Popover/ProfileLinksOverlay';
import { PopoverTriggerButton as BasePopoverTriggerButton } from 'components/Masthead/Header/Popover/TriggerButton';

const PopoverTriggerButton = styled(BasePopoverTriggerButton)`
  display: inline-flex;
  gap: 8px;

  & > * {
    margin-inline-start: 0 !important;
  }
`;

type Props = {
  profileLinks: MastheadLinkOrLinkListArray;
};

export const NavBarProfileLinksPopover = ({ profileLinks }: Props) => {
  // needs to be vertical friendly
  const { isFetching, user } = useCustomer();
  const ubi = useUbiMastheadHeader();
  const { handlers, open } = useDropdown('profile-links-popover');

  const onKeyDown: KeyboardEventHandler = e => {
    if (!isFetching) {
      ubi.logAvatarInteraction(!open);
      handlers.handleOnKeyDown(e);
    }
  };

  const onMouseDown: MouseEventHandler = e => {
    if (!isFetching) {
      ubi.logAvatarInteraction(!open);
      handlers.handleOnMouseDown(e);
    }
  };

  const onMouseEnter: MouseEventHandler = () => {
    if (!isFetching) {
      ubi.logAvatarInteraction(!open);
      handlers.handleOnMouseEnter();
    }
  };

  const onMouseLeave: MouseEventHandler = () => {
    if (!isFetching) {
      ubi.logAvatarInteraction(!open);
      handlers.handleOnMouseLeave();
    }
  };

  return (
    <PopoverTrigger
      onShow={() => {}}
      onHide={() => {}}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      placement="bottomLeft"
      overlay={open && <NavBarProfileLinksPopoverOverlay isLoggedIn={user !== null} profileLinks={profileLinks} />}
    >
      <PopoverTriggerButton open={open} onKeyDown={onKeyDown} onMouseDown={onMouseDown}>
        <NavBarAvatar loading={isFetching} src={user?.images?.[0]?.url || ''} />
        <span>Account</span>
      </PopoverTriggerButton>
    </PopoverTrigger>
  );
};
